import { render, staticRenderFns } from "./register.vue?vue&type=template&id=a14f831a&scoped=true"
import script from "./register.vue?vue&type=script&lang=ts"
export * from "./register.vue?vue&type=script&lang=ts"
import style0 from "./register.vue?vue&type=style&index=0&id=a14f831a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a14f831a",
  null
  
)

export default component.exports